import type { Category } from '@/types';
import { SectionTitle } from '@atoms/SectionTitle';
import { CategoryIcon, resolveCategoryIcon } from '@/utils/categoryIcons';
import { mediaUrl } from '@/utils/mediaUrl';

interface CategoryGridProps {
  categories: Category[];
  onSelect?: (category: Category) => void;
}

export function CategoryGrid({ categories, onSelect }: CategoryGridProps) {
  if (!categories.length) return null;

  return (
    <section id="categories" className="section-container scroll-mt-24 py-16 md:py-20">
      <SectionTitle
        title="Ürün "
        accent="Kategorileri"
        subtitle="İhtiyacınıza uygun kategoriyi seçin ve ürünleri keşfedin."
      />
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6">
        {categories.map((cat) => {
          const iconKey = resolveCategoryIcon(cat.name, cat.icon);
          const img = mediaUrl(cat.image);
          return (
            <button
              key={cat.id}
              type="button"
              onClick={() => onSelect?.(cat)}
              className="card-elevated group flex flex-col items-center gap-3 p-5 text-center hover:-translate-y-0.5"
            >
              <div className="flex h-14 w-14 items-center justify-center overflow-hidden rounded-xl border border-slate-200 bg-slate-50 transition group-hover:border-brand-200 group-hover:bg-brand-50">
                {img ? (
                  <img src={img} alt="" className="h-full w-full object-cover" />
                ) : (
                  <CategoryIcon name={cat.name} icon={iconKey} />
                )}
              </div>
              <span className="text-sm font-semibold text-slate-900">{cat.name}</span>
            </button>
          );
        })}
      </div>
    </section>
  );
}
